export const transformQueryValues = queryValues => {
  if (queryValues[0]?.searchType) {
    if (queryValues.length > 0 && queryValues[0].searchType === 'EXACT__SEARCH') {
      return {
        value: queryValues.flatMap(query => query.bobjectPicklistValue),
        type: queryValues[0].searchType,
      };
    }
    return queryValues.map(query => ({
      value: query.textValue === '' ? query.bobjectPicklistValue : query.textValue,
      type: query.searchType,
    }));
  }
  if (
    queryValues[0] !== undefined &&
    queryValues[0].textValue &&
    queryValues[0].textValue !== '__MATCH_EMPTY_ROWS__'
  ) {
    return queryValues[0].textValue?.split(',');
  }
  return queryValues.map(value => value.bobjectPicklistValue);
};

export const generateQueryFromFilters = bobjectViewFilters =>
  bobjectViewFilters?.length > 0
    ? bobjectViewFilters.reduce(
        (prev, curr) => ({
          ...prev,
          [curr.id]: transformQueryValues(curr.values),
        }),
        {},
      )
    : {};
